export default "__VITE_ASSET__RczVe_X9__"